import React, { useEffect, useState } from "react";
import { usePermissions } from "../../PermissionsProvider";
import { User } from "../../model_gen/company";
import { CompanyService } from "../../services/CompanyService";
import { 
  UserPlusIcon
} from "lucide-react";
import { Button } from "../ui/button";
import { Tooltip } from "../ui/tooltip";
import UsersTable from "./UsersTable";
import PendingUsersTable from "./PendingUsersTable";

const Users: React.FC = () => {
  const { apiKey } = usePermissions();
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);

  useEffect(() => {
    fetchUsers();
  }, [apiKey]);

  const fetchUsers = () => {
    if (isLoading) return;

    setIsLoading(true);
    CompanyService.getOrganizationUsers(setIsLoading, apiKey).subscribe(
      (data: User[]) => {
        setUsers(data);
        setIsLoading(false);
      },
      (error: any) => {
        console.error("Error fetching users:", error);
        setIsLoading(false);
      }
    );
  };

  // Separate active and pending users
  const activeUsers = users.filter((user) => !user.pending);
  const pendingUsers = users.filter((user) => user.pending);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-gc-med text-foreground">Users</h3>
          <p className="text-sm text-muted-foreground">Manage organization members and invitations</p>
        </div>
        <Tooltip content="Contact support@trymaitai.ai to invite users">
          <Button disabled className="gap-2">
            <UserPlusIcon className="w-4 h-4" />
            Invite User
          </Button>
        </Tooltip>
      </div>

      {/* Active Users */}
      <UsersTable
        users={activeUsers}
        loading={isLoading}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
      />

      {/* Pending Users */}
      <PendingUsersTable
        pendingUsers={pendingUsers}
        loading={isLoading}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default Users;
